'use client';
import { useScrollIntoView } from '@brand/utils';
import { Header, Image, Spacer, Typo } from 'components/ui-kit';
import { ButtonWithWidth } from 'components/ui-kit/button-with-width';
import { aboutPageService } from 'modules/about/services';
import { memo, useMemo } from 'react';
import styles from './about-page-video.module.scss';

export const AboutPageVideo = memo(function AboutPageVideo() {
  const {
    href,
    thumbnail: { src, srcSet, alt },
  } = useMemo(() => aboutPageService.getVideoMedia(), []);
  const [scrollToRef, scrollToHandler] = useScrollIntoView<HTMLDivElement>();

  return (
    <div ref={scrollToRef} className={styles.aboutPageVideo}>
      <Image srcSet={srcSet} src={src} alt={alt} />
      <div className={styles.aboutPageVideoTitle}>
        <Typo variant="l" color="white" align="center">
          вы всегда на виду
        </Typo>
        <Spacer size={32} />
        <Header level={2} color="white" align="center">
          Решительные и смелые
          <br />
          здесь и в любой точке
        </Header>
        <Spacer size={24} />
        <ButtonWithWidth
          href={href}
          type="outer-link"
          target="_blank"
          size="l"
          variant="white"
          width={240}
        >
          Смотреть
        </ButtonWithWidth>
      </div>
      <div className={styles.aboutPageVideoAnchor} onClick={scrollToHandler}>
        <Typo
          color="black"
          className={styles.aboutPageVideoAnchorButton}
          weight="500"
        >
          Смотри видео
        </Typo>
        <div className={styles.aboutPageVideoAnchorLine} />
      </div>
    </div>
  );
});
